/**
 * STORE TOPページのみのts
 */


/**
 * バナーの初期化
 */
const initStoreBannerL = () => {
    const swiper = new Swiper('.js-banner-l', {
        loop: true,
        autoplay: {
            delay: 3000,
            disableOnInteraction: false,
        },
        slidesPerView: 'auto',
        centeredSlides: true,
        spaceBetween: 10,
        navigation: {
            nextEl: ".banner-l__button-next",
            prevEl: ".banner-l__button-prev",
        },
        breakpoints: {
            481: {
                spaceBetween: 40
            },
        },
        on: {
            afterInit: (swiper) => {
                const dom = document.querySelector(".banner-l");
                dom.classList.add("js-active");
            },
        }
    });
}

$(function () {
  initStoreBannerL();
})
